<script setup lang="ts">
import type { GlossaryThumbFragment } from '#graphql-operations'

interface CardGlossartProps {
  data: GlossaryThumbFragment
}

defineProps<CardGlossartProps>()
</script>

<template>
  <CardDefault
    class="cardGlossary"
    :title="data.title"
    :excerpt="data.textText"
    :description="data.text"
    :to="data.url"
  />
</template>

<style scoped>
.cardGlossary {
  & :deep(p:has(.typo-sans:only-child)) {
    display: none;
  }

  & :deep(p.typo-serif):has(.typo-sans:only-child) {
    display: none;
  }
}
</style>
